import React, { useContext, useEffect, useState } from 'react';
import { AdminContext, UserContext } from '../../../App';
import OrderCard from '../OrderCard.js/OrderCard';
import './OrderList.css'
import OrderHeader from '../OrderHeader/OrderHeader';

const OrderList = () => {
    const [orderList, setOrderList] = useState([])
    const [loggedInUser, setLoggedInUser] = useContext(UserContext)
    useEffect(() => {
        fetch('https://assignment-11-samiun.herokuapp.com/order?email=' + loggedInUser.email)
        .then(res => res.json())
        .then(data => setOrderList(data))
    }, [orderList, loggedInUser.email])
    const [isAdmin, setIsAdmin] = useContext(AdminContext)
    return (
        <div className="row">
            <div className="col-md-2">
                <OrderHeader />
            </div>
            <div className="col-md-10 mt-4">
                <div>
                <h3 className="mb-2">Order List</h3>
                <div className="mt-3 ps-5 pt-5" style={{background: '#F4F7FC', height: '100vh'}}>
                    <div className="row">
                        {
                            orderList.map(order => <OrderCard order={order}/>)
                        }
                    </div>
                </div>
                </div>
            </div>
        </div>
    );
};

export default OrderList;